/* __next_internal_client_entry_do_not_use__ BlogNav auto */import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { NewBaseButton } from "@/components/common/NewBaseButton";
import "./index.css";
import { notLoginHandle } from "@/helpers/blog";
import Image from "next/image";
import { IMG_COMPRESS_SUFFIX, IMG_COMPRESS_SUFFIX_60 } from "@/components/features/common/constant";
import { GenerateIOSLink, GenerateLink } from "@/util";
import { IMPORT_STATUS, useIsImport } from "@/hooks/useIsImport";
import { Translate } from "@/components/topic/Translate";
import { isIOS } from "react-device-detect";
export const BlogNav = props => {
  const {
    articleInfo
  } = props;
  const {
    title,
    intro
  } = articleInfo;
  const {
    importStatus
  } = useIsImport();
  return /*#__PURE__*/_jsxs("header", {
    className: "banner-header",
    children: [/*#__PURE__*/_jsx(Image, {
      src: "https://txcdn-prod-a1art.xiaopiu.com/assets/Resource/seoPage/banner-bg-I4JADQh5.webp" + IMG_COMPRESS_SUFFIX,
      alt: "Blog Banner Background",
      className: "banner-bg-image",
      width: 1920,
      height: 800,
      priority: false,
      fetchPriority: "low",
      loading: "lazy"
    }), /*#__PURE__*/_jsxs("div", {
      className: "banner-header-content",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "banner-text",
        children: [/*#__PURE__*/_jsx("h1", {
          children: title
        }), /*#__PURE__*/_jsx("p", {
          children: intro
        }), importStatus === IMPORT_STATUS.YES ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(NewBaseButton, {
            className: "banner-button",
            preset: "primary",
            style: {
              marginTop: "24px",
              width: "80%"
            },
            size: "huge",
            onClick: () => {
              window.open(isIOS ? GenerateIOSLink("h5_hero") : GenerateLink("h5_hero"));
            },
            children: /*#__PURE__*/_jsx(Translate, {
              translateKey: "Import_App_Button_Two"
            })
          }), /*#__PURE__*/_jsx(NewBaseButton, {
            className: "banner-button",
            preset: "secondary",
            style: {
              marginTop: "24px",
              width: "80%"
            },
            size: "huge",
            onClick: notLoginHandle,
            children: /*#__PURE__*/_jsx(Translate, {
              translateKey: "Import_App_Button"
            })
          })]
        }) : /*#__PURE__*/_jsx(NewBaseButton, {
          className: "banner-button",
          preset: "primary",
          style: {
            marginTop: "24px",
            width: "80%"
          },
          size: "huge",
          onClick: notLoginHandle,
          children: /*#__PURE__*/_jsx(Translate, {
            translateKey: "Seo_Header_Button"
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "banner-image-container",
        children: /*#__PURE__*/_jsx("div", {
          className: "banner-image-mask",
          children: /*#__PURE__*/_jsx("div", {
            className: "banner-image",
            children: /*#__PURE__*/_jsx("img", {
              src: "https://txcdn-prod-a1art.xiaopiu.com/assets/Resource/seoPage/banner-X-E5FOeT.webp" + IMG_COMPRESS_SUFFIX_60,
              alt: "banner",
              loading: "lazy"
            })
          })
        })
      })]
    })]
  });
};